module.exports = __webpack_public_path__ + "img/menu-payments.9d10b8de.svg";